/*!

=========================================================
* Paper Dashboard React - v1.3.2
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { useEffect, useState, } from "react";
import { ToastContainer, toast } from 'react-toastify';
import { Button, ButtonGroup } from 'reactstrap';
import axios from 'axios';
import { db } from '../firebase';
import { doc, getDoc, setDoc, deleteDoc } from "firebase/firestore";
import {
  ListItem,
  Card,
} from "@material-tailwind/react";
import { MdModeEditOutline } from "react-icons/md";
import { useDispatch } from 'react-redux'
import { updateUser, updateAccountType } from '../features/counter/counterSlice';
import { useSelector } from 'react-redux'
import { FaRegEye } from "react-icons/fa6";
import { FaRegEyeSlash } from "react-icons/fa6";
import { Spinner } from 'reactstrap';

function EditProfile() {
  const [name, setName] = useState();
  const [surname, setSurname] = useState();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [passwordBool, setPasswordBool] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState();
  const [confirmPasswordBool, setConfirmPasswordBool] = useState(false);
  const [role, setRole] = useState();
  const [managers, setManagers] = useState([]);
  const [porters, setPorters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch()
  const user = useSelector(state => state.store.user);
  const accountType = useSelector(state => state.store.accountType);

  const openToast = (message) => {
    const Toastify__toast = document.querySelector('.Toastify__toast ');
      if(Toastify__toast === null){
      toast.error(message, {
        position: 'top-center',
      });
    }
  }

  const getUserList = async() => {
    const response = await axios.get('http://localhost:8080/users');

    response.data.forEach(async (user) => {
      if (user.displayName === 'manager') {
        const userRef = doc(db, 'users', user.uid);
        const userSnap = await getDoc(userRef);
        
        if (userSnap.exists()) {
          const userInfo = {
            ...user,
            ...userSnap.data()
          };
          setManagers(prevManagers => [...prevManagers, userInfo]);
        } else {
          console.log("No such document!");
        }
      }
    });
    
    // Iteracja po porterach
    response.data.forEach(async (user) => {
      if (user.displayName === 'porter') {
        const userRef = doc(db, 'users', user.uid);
        const userSnap = await getDoc(userRef);
    
        if (userSnap.exists()) {
          const userInfo = {
            ...user,
            ...userSnap.data()
          };
          setPorters(prevPorters => [...prevPorters, userInfo]);
        } else {
          console.log("No such document!");
        }
      }
    });
  }

  useEffect(() => {
    getUserList();
  }, [])

  const updateAccount = async (e) => {
    e.preventDefault();
    
    if ((password !== undefined ? password : user.password) === confirmPassword) {
      setIsLoading(true);
  
      try {
        // Wysyłanie danych do API za pomocą axios
        const res = await axios.post('http://localhost:8080/updateAccount', {
          email: (email === undefined || email === '' ? user.email : email),
          password: (password === undefined || password === '' ? user.password : password),
          displayName: (role !== undefined ? role.toLowerCase() : user.role.toLowerCase()),
          uid: user.uid
        });
        
        // Uaktualnianie danych użytkownika w Firestore
        const userRef = doc(db, 'users', res.data); // Tworzymy referencję do dokumentu
        await setDoc(userRef, {
          name: (name === undefined ? user.name : name),
          surname: (surname === undefined ? user.surname : surname),
          password: (password === undefined ? user.password : password),
          role: (role === undefined ? user.role : role)
        });
  
        window.location.reload(); // Przeładowanie strony po sukcesie
  
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false); // Wyłącz ładowanie po zakończeniu procesu
      }
  
    } else {
      openToast('The passwords must match');
    }
  };

  useEffect(() => {
    const buttonGroup = document.querySelectorAll('#btn-group')[0];
    if(buttonGroup){
      Array.prototype.slice.call(buttonGroup.children).forEach((button) => {
        if(button.innerHTML === accountType){
          button.classList.add('activeButton');
        }else{
          button.classList.remove('activeButton');
        }
      })
    }
  }, [accountType])

  useEffect(() => {
    if(porters.length > 0 && managers.length > 0){
      const lists = document.querySelectorAll('.list');
      if(lists){
        Array.prototype.slice.call(lists).forEach((list) => {
          if(list.getAttribute('data-id') === user.uid){
            list.classList.add('active');
          }else{
            list.classList.remove('active');
          }
        })
      }
    }
  }, [user, accountType, porters, managers])

  const editUser = (user) => {
    dispatch(updateUser(user));
  } 

  const handleDelete = async () => {
    try {
      if ((password !== undefined ? password : user.password) === confirmPassword) {
        setIsLoading(true);
  
        // Wysyłanie żądania usunięcia użytkownika do serwera
        await axios.put(`http://localhost:8080/delete/${user.uid}`);
  
        // Tworzenie referencji do dokumentu użytkownika w Firestore
        const userRef = doc(db, 'users', user.uid);
  
        // Usuwanie dokumentu użytkownika
        await deleteDoc(userRef);
  
        // Przeładowanie strony po pomyślnym usunięciu
        window.location.reload(true);
        
      } else {
        openToast('The passwords must match');
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false); // Wyłączenie stanu ładowania
    }
  };

  return (
    <>
     <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css"
        rel="stylesheet"
        integrity="sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN"
        crossOrigin="anonymous"
      />
      <ToastContainer style={{ width: '800px' }} autoClose={2000}/>
      <div className="content" style={{ display: 'flex', flexDirection: 'row' }}>
      <Card className='bg-my-black min-h-full max-h-full' style={{ borderRadius: '8px', width: '20%', padding: '5px', overflowY: 'auto' }}>
        <ButtonGroup id='btn-group'>
          <Button style={{ width: '81px' }} onClick={() => { dispatch(updateAccountType('Manager')); dispatch(updateUser({})); setConfirmPassword() }}>Manager</Button>
          <Button onClick={() => { dispatch(updateAccountType('Porter')); dispatch(updateUser({})); setConfirmPassword(); }}>Porter</Button>
        </ButtonGroup>
        {(accountType == 'Manager' ? (managers.length > 0  ? managers.map((user, index) => (
          <ListItem style={{ color: '#fff', height: '45px' }} data-id={user.uid} onClick={() => editUser(user)} className="py-1 pr-1 pl-4 list">
            <div style={{ width: '100%', height: '100%', display: 'flex', flexFlow: 'row nowrap', justifyContent: 'space-between', alignItems: 'center' }}>
              {user.name} {user.surname}
              <MdModeEditOutline style={{ width:'1.25em', height: '1.25em'}}/>
            </div>
          </ListItem>
        )) : '') : (porters.length > 0  ? porters.map((user, index) => (
          <ListItem style={{ color: '#fff', height: '45px' }} data-id={user.uid} onClick={() => editUser(user)} className="py-1 pr-1 pl-4 list">
            <div style={{ width: '100%', height: '100%', display: 'flex', flexFlow: 'row nowrap', justifyContent: 'space-between', alignItems: 'center' }}>
              {user.name} {user.surname}
              <MdModeEditOutline style={{ width:'1.25em', height: '1.25em'}}/>
            </div>
          </ListItem>
        )) : ''))}
      </Card>
      <div style={{ width: '80%' }} className="flex min-h-full flex-col justify-center px-6 lg:px-8">
      {(isLoading ? <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm"><div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} className="mb-3">
      <Spinner
        style={{ marginLeft: '1rem' }}
        color="dark"
        size=""
      >
        Loading...
      </Spinner></div></div> : <><div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <h2 className="text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">Edit {accountType}</h2>
      </div>
      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <div className="mb-3">
            <label htmlFor="formGroupExampleInput2" className="form-label">
            Name
            </label>
            <input
              type="text"
              className="form-control"
              id="formGroupExampleInput2"
              placeholder="name"
              name='name'
              value={(name === undefined ? (Object.keys(user).length > 0 ? user.name : '') : name)}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="formGroupExampleInput2" className="form-label">
            Surname
            </label>
            <input
              type="text"
              className="form-control"
              id="formGroupExampleInput2"
              placeholder="surname"
              name='surname'
              value={(surname === undefined ? (Object.keys(user).length > 0 ? user.surname : '') : surname)}
              onChange={(e) => setSurname(e.target.value)}
              required
            />
          </div>
        <div className="mb-3">
            <label htmlFor="formGroupExampleInput2" className="form-label">
            Email
            </label>
            <input
              type="text"
              className="form-control"
              id="formGroupExampleInput2"
              placeholder="office@slampoland.pl"
              name='email'
              value={(email === undefined ? (Object.keys(user).length > 0 ? user.email : '') : email)}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
    
          <div className="mb-3">
            <label htmlFor="formGroupExampleInput" className="form-label">
              Password
            </label>
            <div style={{ display: 'flex', flexFlow: 'row nowarp', alignItems: 'center', position: 'relative' }}>
              <input
                type={(passwordBool ? 'text' : "password")}
                className="form-control"
                id="formGroupExampleInput"
                placeholder='password'
                name='password'
                value={(password === undefined ? (Object.keys(user).length > 0 ? user.password : '') : password)}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <span style={{ position: 'absolute', right: '10px' }}>{(passwordBool ? <FaRegEyeSlash style={{ width: '18px' }} onClick={() => setPasswordBool(false)}/> : <FaRegEye onClick={() => setPasswordBool(true)}/>)}</span>
            </div>
          </div>
          <div className="mb-3">
            <label htmlFor="formGroupExampleInput" className="form-label">
              Confir password
            </label>
            <div style={{ display: 'flex', flexFlow: 'row nowarp', alignItems: 'center', position: 'relative' }}>
              <input
                type={(confirmPasswordBool ? 'text' : "password")}
                className="form-control"
                id="formGroupExampleInput"
                placeholder='confirm password'
                name='confirmPassword'
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <span style={{ position: 'absolute', right: '10px' }}>{(confirmPasswordBool ? <FaRegEyeSlash style={{ width: '18px' }} onClick={() => setConfirmPasswordBool(false)}/> : <FaRegEye onClick={() => setConfirmPasswordBool(true)}/>)}</span>
            </div>
          </div>
          <div className="mb-3">
            <label htmlFor="formGroupExampleInput" className="form-label">
              Role
            </label>
            <select
              className="form-control"
              id="formGroupExampleInput"
              placeholder=''
              name='role'
              value={(role === undefined ? (Object.keys(user).length > 0 ? user.role : '') : role)}
              onChange={(e) => setRole(e.target.value)}
              required
            >
              <option value='porter'>Porter</option>
              <option value='manager'>Manager</option>
            </select>
          </div>
          <div style={{ display: 'flex', flexFlow: 'row nowrap', justifyContent: 'space-between' }}>
            <button onClick={handleDelete} style={{ width: '140px' }} className="btn btn-error">Delete</button>
            <button style={{ width: '140px', textTransform: 'capitalize' }} onClick={(e) => updateAccount(e)} className="flex justify-center rounded-md btn btn-warning px-3 py-1.5 text-sm font-semibold leading-6 shadow-sm ">Update profile</button>
          </div>
      </div></>)}
    </div>
    </div>
    </>
  );
}

export default EditProfile;
